import { CoreoRecord, CoreoRecordSyncStatus } from '../../types';

/**
 * Matches FORM_REMOVE_RECORD_ASSOCIATE "immediately slice out of associates list" branch
 * (see forms.reducer): only staging associates that have never been assigned a SQLite row
 * (`id === null`). Associates with a row id use PENDING_DELETE until save.
 */
export const associateSliceImmediatelyOnRemove = (existingAssociate: CoreoRecord): boolean => {
  if (existingAssociate.id !== null && existingAssociate.id !== undefined) {
    return false;
  }
  return (
    existingAssociate.syncState === CoreoRecordSyncStatus.PENDING_UPDATE ||
    existingAssociate.syncState === CoreoRecordSyncStatus.PENDING_CREATE ||
    existingAssociate.syncState === CoreoRecordSyncStatus.DRAFT ||
    existingAssociate.syncState === CoreoRecordSyncStatus.INCOMPLETE
  );
};
